<template>
  <div class="container" v-title data-title="我的邀请记录">
    <div class="record-container">
      <div class="record-container-tip flex main-space-between cross-center">
        <span class="record-name">昵称</span>
        <span class="record-time">注册时间</span>
      </div>
    </div>

    <!-- 列表 -->
    <div class="container-list">
      <!-- 列表 -->
      <div class="record-container-cell flex main-space-between cross-center" v-for="(item, index) in invitationRecords" :key="index">
        <span class="record-name">{{item.name}}</span>
        <span class="record-time">{{item.registerTime | dateAndMinTime}}</span>
      </div>

      <div v-if="!invitationRecords || invitationRecords.length === 0" class="record-container-cell flex main-center cross-center">
        <span style="font-size: 14px; color: #999999FF;">暂无记录</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as InvitationsApi from "../../../api/Invitation.js";

export default {
  data() {
    return {
      invitationRecords: [],
    };
  },
  created() {
    this.doReqeustStudentInvitationRecords()
  },
  methods: {
    /**
     * 查询学生邀请记录
     */
    async doReqeustStudentInvitationRecords() {
      const invitation = await InvitationsApi.doReqeustStudentInvitations()
      this.invitationRecords = invitation.invRecords
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  height: 100%;
  width: 100vw;
  position: relative;

  .container-list {
    padding-top: 66px;
  }

  .record-container {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    height: 66px;
    background-color: white;
  // 邀请记录提示框
    .record-container-tip {
      position: absolute;
      left: 16px;
      right: 16px;
      top: 16px;
      height: 34px;
      background: #e6f8f4;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      padding: 0 32px;

      span {
        color: #21bea1;
      }
    }
  }

  // 邀请记录内容
  .record-container-cell {
    margin: 0 16px;
    padding: 0 32px;
    height: 44px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 0px #eeeeee;
    opacity: 1;

    span {
      color: #333333ff;
    }
  }

  .record-name {
    width: 50%;
    overflow: hidden; /*超出部分隐藏*/
    text-overflow: ellipsis; /*超出部分省略号表示*/
    white-space: nowrap; /*强制单行显示*/
    height: 16px;
    font-size: 15px;
    font-weight: light;
    line-height: 16px;
  }

  .record-time {
    width: 50%;
    white-space: nowrap; /*强制单行显示*/
    height: 16px;
    font-size: 15px;
    font-weight: light;
    line-height: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/invitation/student/InvitationStudentRecord.vue